import { gql } from '@apollo/client';
import {
  CART_FIELDS,
  CART_FIELDS_WITH_PREVIEW_DISCOUNT,
} from './cartsv2/fragments';

export const CREATE_CART = gql`
  mutation createCart(
    $funnelData: CreateFunnelDataInput!
    $cartData: CreateCartInput!
  ) {
    createCart(funnelData: $funnelData, cartData: $cartData) {
      uuid
      funnelData
    }
  }
`;

export const CREATE_AND_RETURN_CART = gql`
  mutation createAndReturnCart(
    $funnelData: CreateFunnelDataInput!
    $cartData: CreateCartInput!
  ) {
    createCart(funnelData: $funnelData, cartData: $cartData) {
      ...allCartFields
    }
  }
  ${CART_FIELDS}
`;

export const CREATE_AND_RETURN_CART_WITH_PREVIEW_DISCOUNT = gql`
  mutation createAndReturnCartWithPreviewDiscount(
    $funnelData: CreateFunnelDataInput!
    $cartData: CreateCartInput!
    $previewFunnelDiscountCode: Boolean
  ) {
    createCart(funnelData: $funnelData, cartData: $cartData) {
      ...allCartFieldsWithPreviewDiscount
    }
  }
  ${CART_FIELDS_WITH_PREVIEW_DISCOUNT}
`;

export const UPDATE_CART_WITH_PREVIEW_DISCOUNT = gql`
  mutation updateCartWithPreviewDiscount(
    $funnelData: UpdateFunnelDataInput
    $cartData: UpdateCartInput
    $uuid: UUID!
    $previewFunnelDiscountCode: Boolean
  ) {
    updateCart: updateCartV2(
      funnelData: $funnelData
      cartData: $cartData
      uuid: $uuid
    ) {
      ...allCartFieldsWithPreviewDiscount
      ... on Cart {
        cartError {
          validation {
            quantity {
              message
              deliveryId
            }
            status {
              message
            }
            catalog {
              message
            }
            customizeBy {
              message
            }
          }
        }
      }
      ... on CartError {
        validation {
          status {
            message
          }
        }
      }
    }
  }
  ${CART_FIELDS_WITH_PREVIEW_DISCOUNT}
`;

// @todo we should really use fragments to ensure we're querying for same fields, but we can fix that as tech-debt.
export const UPDATE_CART = gql`
  mutation updateCart(
    $funnelData: UpdateFunnelDataInput
    $cartData: UpdateCartInput
    $uuid: UUID!
  ) {
    updateCart: updateCartV2(
      funnelData: $funnelData
      cartData: $cartData
      uuid: $uuid
    ) {
      ...allCartFields
      ... on Cart {
        cartError {
          validation {
            quantity {
              message
              deliveryId
            }
            status {
              message
            }
            catalog {
              message
            }
            customizeBy {
              message
            }
          }
        }
      }
      ... on CartError {
        validation {
          status {
            message
          }
        }
      }
    }
  }
  ${CART_FIELDS}
`;

export const ADD_VARIANT_TO_CART_DELIVERY = gql`
  mutation addVariantToCartDelivery(
    $cartUUID: UUID!
    $cartDeliveryId: Int!
    $variantInput: AddVariantToCartDeliveryInput!
  ) {
    addVariantToCartDelivery: addVariantToCartDeliveryV2(
      cartUUID: $cartUUID
      cartDeliveryId: $cartDeliveryId
      variantInput: $variantInput
    ) {
      ... on CartDelivery {
        cart {
          uuid
          userId
          orderOn
          deliveryDates
          tenantEligibilityConfigLogicalId
          modifiedDuringFunnel
          createdFromPersonalizedPlan
          cartDeliveries {
            id
            createdAt
            updatedAt
            status
            deliveryType
            estimatedTransitTime
            estimatedDeliveryDate
            deliveryDate
            lineItems {
              id
              createdAt
              updatedAt
              variantId
              variant
              price
              quantity
            }
          }
          funnelData
          metroId
          cartLedger {
            subtotal
            discountTotal
            deliveryTotal
            tax
            grandTotal
            creditTotal
            precreditTotal
          }
          discount {
            amount
            code
            type
          }
          status
          cartError {
            validation {
              quantity {
                message
                deliveryId
              }
            }
          }
        }
      }
      ... on CartError {
        validation {
          status {
            message
          }
          quantity {
            message
            deliveryId
          }
          soldOutItem {
            message
          }
        }
      }
    }
  }
`;

export const ADD_VARIANT_TO_CART_DELIVERY_WITH_PREVIEW_DISCOUNT = gql`
  mutation addVariantToCartDeliveryWithPreviewDiscount(
    $cartUUID: UUID!
    $cartDeliveryId: Int!
    $variantInput: AddVariantToCartDeliveryInput!
    $previewFunnelDiscountCode: Boolean
  ) {
    addVariantToCartDelivery: addVariantToCartDeliveryV2(
      cartUUID: $cartUUID
      cartDeliveryId: $cartDeliveryId
      variantInput: $variantInput
    ) {
      ... on CartDelivery {
        cart {
          uuid
          userId
          orderOn
          deliveryDates
          tenantEligibilityConfigLogicalId
          modifiedDuringFunnel
          createdFromPersonalizedPlan
          cartDeliveries {
            id
            createdAt
            updatedAt
            status
            deliveryType
            estimatedTransitTime
            estimatedDeliveryDate
            deliveryDate
            lineItems {
              id
              createdAt
              updatedAt
              variantId
              variant
              price
              quantity
            }
          }
          funnelData
          metroId
          cartLedger(previewFunnelDiscountCode: $previewFunnelDiscountCode) {
            subtotal
            discountTotal
            deliveryTotal
            tax
            grandTotal
            creditTotal
            precreditTotal
          }
          status
          cartError {
            validation {
              quantity {
                message
                deliveryId
              }
            }
          }
        }
      }
      ... on CartError {
        validation {
          status {
            message
          }
          quantity {
            message
            deliveryId
          }
          soldOutItem {
            message
          }
        }
      }
    }
  }
`;

export const REMOVE_VARIANT_FROM_CART_DELIVERY = gql`
  mutation removeVariantFromCartDelivery(
    $cartUUID: UUID!
    $cartDeliveryId: Int!
    $variantInput: RemoveVariantInput!
  ) {
    removeVariantFromCartDelivery: removeVariantFromCartDeliveryV2(
      cartUUID: $cartUUID
      cartDeliveryId: $cartDeliveryId
      variantInput: $variantInput
    ) {
      ... on CartDelivery {
        cart {
          uuid
          userId
          orderOn
          deliveryDates
          tenantEligibilityConfigLogicalId
          modifiedDuringFunnel
          createdFromPersonalizedPlan
          cartDeliveries {
            id
            createdAt
            updatedAt
            status
            deliveryType
            estimatedTransitTime
            estimatedDeliveryDate
            deliveryDate
            lineItems {
              id
              createdAt
              updatedAt
              variantId
              variant
              price
              quantity
            }
          }
          funnelData
          metroId
          cartLedger {
            subtotal
            creditTotal
            discountTotal
            deliveryTotal
            tax
            grandTotal
            precreditTotal
          }
          discount {
            amount
            code
            type
          }
          status
          cartError {
            validation {
              status {
                message
              }
              quantity {
                message
                deliveryId
              }
            }
          }
        }
      }
      ... on CartError {
        validation {
          status {
            message
          }
          quantity {
            message
            deliveryId
          }
        }
      }
    }
  }
`;

export const REMOVE_VARIANT_FROM_CART_DELIVERY_WITH_PREVIEW_DISCOUNT = gql`
  mutation removeVariantFromCartDeliveryWithPreviewDiscount(
    $cartUUID: UUID!
    $cartDeliveryId: Int!
    $variantInput: RemoveVariantInput!
    $previewFunnelDiscountCode: Boolean
  ) {
    removeVariantFromCartDelivery: removeVariantFromCartDeliveryV2(
      cartUUID: $cartUUID
      cartDeliveryId: $cartDeliveryId
      variantInput: $variantInput
    ) {
      ... on CartDelivery {
        cart {
          uuid
          userId
          orderOn
          deliveryDates
          tenantEligibilityConfigLogicalId
          modifiedDuringFunnel
          createdFromPersonalizedPlan
          cartDeliveries {
            id
            createdAt
            updatedAt
            status
            deliveryType
            estimatedTransitTime
            estimatedDeliveryDate
            deliveryDate
            lineItems {
              id
              createdAt
              updatedAt
              variantId
              variant
              price
              quantity
            }
          }
          funnelData
          metroId
          cartLedger(previewFunnelDiscountCode: $previewFunnelDiscountCode) {
            subtotal
            creditTotal
            discountTotal
            deliveryTotal
            tax
            grandTotal
            precreditTotal
          }
          status
          cartError {
            validation {
              status {
                message
              }
              quantity {
                message
                deliveryId
              }
            }
          }
        }
      }
      ... on CartError {
        validation {
          status {
            message
          }
          quantity {
            message
            deliveryId
          }
        }
      }
    }
  }
`;

export const ADD_CODE_TO_CART = gql`
  mutation addCodeToCart($code: String!, $uuid: UUID!) {
    addCodeToCart: addCodeToCartV2(code: $code, uuid: $uuid) {
      ... on Cart {
        uuid
        userId
        orderOn
        deliveryDates
        funnelData
        metroId
        tenantEligibilityConfigLogicalId
        modifiedDuringFunnel
        createdFromPersonalizedPlan
        cartDeliveries {
          id
          createdAt
          updatedAt
          status
          deliveryType
          estimatedTransitTime
          estimatedDeliveryDate
          deliveryDate
          lineItems {
            id
            createdAt
            updatedAt
            variantId
            variant
            price
            quantity
          }
        }
        cartLedger {
          subtotal
          discountTotal
          deliveryTotal
          creditTotal
          tax
          grandTotal
          precreditTotal
        }
        discount {
          amount
          code
          type
        }
        status
        discountErrors
        appliedCodeType
        cartError {
          validation {
            quantity {
              message
              deliveryId
            }
            status {
              message
            }
            catalog {
              message
            }
            customizeBy {
              message
            }
          }
        }
      }
      ... on CartError {
        validation {
          status {
            message
          }
        }
      }
    }
  }
`;

export const REMOVE_CODE_FROM_CART = gql`
  mutation removeCodeFromCart($uuid: UUID!) {
    removeCodeFromCart: removeCodeFromCart(uuid: $uuid) {
      ... on Cart {
        uuid
        userId
        orderOn
        deliveryDates
        funnelData
        metroId
        tenantEligibilityConfigLogicalId
        modifiedDuringFunnel
        createdFromPersonalizedPlan
        cartDeliveries {
          id
          createdAt
          updatedAt
          status
          deliveryType
          estimatedTransitTime
          estimatedDeliveryDate
          deliveryDate
          lineItems {
            id
            createdAt
            updatedAt
            variantId
            variant
            price
            quantity
          }
        }
        cartLedger {
          subtotal
          discountTotal
          deliveryTotal
          creditTotal
          tax
          grandTotal
          precreditTotal
        }
        discount {
          amount
          code
          type
        }
        status
        cartError {
          validation {
            quantity {
              message
              deliveryId
            }
            status {
              message
            }
            catalog {
              message
            }
            customizeBy {
              message
            }
          }
        }
      }
      ... on CartError {
        validation {
          status {
            message
          }
        }
      }
    }
  }
`;

export const REPRICE_CART = gql`
  mutation repriceCart($uuid: UUID!) {
    repriceCart: repriceCartV2(uuid: $uuid) {
      ... on Cart {
        uuid
        userId
        orderOn
        deliveryDates
        funnelData
        status
        tenantEligibilityConfigLogicalId
        modifiedDuringFunnel
        cartDeliveries {
          id
          createdAt
          updatedAt
          status
          deliveryType
          estimatedTransitTime
          estimatedDeliveryDate
          deliveryDate
          lineItems {
            id
            createdAt
            updatedAt
            variantId
            variant
            price
            quantity
          }
        }
        cartLedger {
          subtotal
          discountTotal
          deliveryTotal
          creditTotal
          tax
          grandTotal
          precreditTotal
        }
        discount {
          amount
          code
          type
        }
      }
      ... on CartError {
        validation {
          status {
            message
          }
        }
      }
    }
  }
`;

/**
 * Update an existing cart delivery.
 *
 * Extend return type if you need.
 */
export const UPDATE_CART_DELIVERY = gql`
  mutation updateCartDelivery(
    $id: Int!
    $deliveryData: UpdateCartDeliveryInput!
  ) {
    updateCartDelivery: updateCartDeliveryV2(
      id: $id
      deliveryData: $deliveryData
    ) {
      ... on CartDelivery {
        id
        status
        estimatedTransitTime
        estimatedDeliveryDate
      }
      ... on CartError {
        validation {
          status {
            message
          }
          soldOutItem {
            message
          }
        }
      }
    }
  }
`;

export const EVALUATE_DRAFT_CART = gql`
  mutation EvaluateDraftCart(
    $draftCart: EvaluateDraftCartInput!
    $zip: String!
    $state: String
    $recurringSubscription: Boolean!
    $tenantEligibilityConfigLogicalId: String
  ) {
    evaluateDraftCart(
      draftCart: $draftCart
      zip: $zip
      state: $state
      recurringSubscription: $recurringSubscription
      tenantEligibilityConfigLogicalId: $tenantEligibilityConfigLogicalId
    ) {
      discount {
        code
        amount
        type
      }
      deliveryDates
      cartDeliveries {
        estimatedTransitTime
        estimatedDeliveryDate
        deliveryDate
        lineItems {
          variantId
          quantity
          price
          variant
        }
      }
      cartLedger {
        subtotal
        discountTotal
        creditTotal
        deliveryTotal
        tax
        precreditTotal
        grandTotal
      }
      cartError {
        validation {
          quantity {
            message
          }
          catalog {
            message
          }
          soldOutItem {
            message
          }
        }
      }
    }
  }
`;

export const UPDATE_CART_V2 = gql`
  mutation UpdateCartV2($uuid: UUID!, $cartData: UpdateCartInput!) {
    updateCartV2(uuid: $uuid, cartData: $cartData) {
      ... on CartError {
        __typename
        validation {
          quantity {
            message
          }
          catalog {
            message
          }
          status {
            message
          }
          soldOutItem {
            message
          }
        }
      }
      ... on Cart {
        __typename
        uuid
        userId
        legacyOrderId
        status
        funnelData
        deliveryDates
        cartError {
          validation {
            quantity {
              message
            }
            status {
              message
            }
            catalog {
              message
            }
          }
        }
        cartDeliveries {
          id
          createdAt
          updatedAt
          status
          deliveryType
          estimatedTransitTime
          estimatedDeliveryDate
          deliveryDate
          lineItems {
            id
            createdAt
            updatedAt
            variantId
            variant
            price
            quantity
          }
        }
        cartLedger {
          subtotal
          discountTotal
          creditTotal
          deliveryTotal
          tax
          precreditTotal
          grandTotal
        }
      }
    }
  }
`;

export const EMPTY_CART_DELIVERY = gql`
  mutation emptyCartDelivery($cartUUID: UUID!, $cartDeliveryId: Int!) {
    emptyCartDelivery: emptyCartDeliveryV2(
      cartUUID: $cartUUID
      cartDeliveryId: $cartDeliveryId
    ) {
      ... on CartDelivery {
        cart {
          uuid
          userId
          orderOn
          deliveryDates
          tenantEligibilityConfigLogicalId
          modifiedDuringFunnel
          cartDeliveries {
            id
            createdAt
            updatedAt
            status
            deliveryType
            estimatedTransitTime
            estimatedDeliveryDate
            deliveryDate
            lineItems {
              id
              createdAt
              updatedAt
              variantId
              variant
              price
              quantity
            }
          }
          funnelData
          cartLedger {
            subtotal
            creditTotal
            discountTotal
            deliveryTotal
            tax
            grandTotal
            precreditTotal
          }
          discount {
            amount
            code
            type
          }
          status
          cartError {
            validation {
              status {
                message
              }
              quantity {
                message
                deliveryId
              }
            }
          }
        }
      }
      ... on CartError {
        validation {
          status {
            message
          }
          quantity {
            message
            deliveryId
          }
        }
      }
    }
  }
`;
